import React, { useState, useEffect } from 'react';
import CardTwo from './CardTwo';
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';

function Firmware() {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  // Update `isMobileView` on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cardsData = [

    {
      img: '/img/diagnostics.jpg',
      title: 'Diagnostics(Board and Chip Level)',
      points: [
  "Boot Loaders",
  "Porting of software on various platforms",
  "Device drivers ( Linux/ Vx-Works/ Windows etc )",
  "Network Stack development, porting and customizing as per customer requirement",
  "Network Management System (NMS)/ Elementary Management System (EMS)",
  "CLI",
  "SNMP V1/V2/V3",
  "Web based management",
  "Microcontroller based software development",
  "Design analysis and validation"
],

    },


    {
      img: '/img/girl.jpg',
      title: " FPGA",
      points: [
        "Hardware development with FPGA",
        "FPGA verification",
        "Synthesis and simulation",
        "HDL coding VHDL/Verilog",
        "Place and route",
        "Timing model",
        "Net list generation",
 "Design and implementation of custom hardware logic using FPGA platforms.",
  "Optimization of FPGA-based systems for power efficiency and speed.",
  "Development of IP cores for modular and reusable hardware components.",
  "Integration of FPGA designs with embedded systems and external peripherals.",
  "Support for real-time applications with low-latency and high-throughput requirements."
],


    },

    {
      img: '/img/bare.jpg',
      title: 'Bare-Metal Programming',
      points: [
  "Direct hardware control for performance optimization and minimal overhead.",
  "No operating system: Writing code that directly interacts with the microcontroller or hardware.",
  "Efficient resource usage: Maximizing the use of limited resources like memory and processing power.",
  "Low-level debugging: Using debugging tools like JTAG and serial monitors to troubleshoot hardware directly.",
  "Custom peripherals and communication protocols tailored to specific applications.",
  "Real-time constraints: Ensuring deterministic and time-sensitive behavior in embedded systems.",
  "Bootloader development: Creating custom bootloaders for firmware updates and system initialization.",
  "Hardware abstraction: Building low-level software to interface with sensors, actuators, and other hardware devices.",
  "Minimal dependencies: Avoiding external libraries and relying on minimal hardware-specific code."
],

    },
    {
      img: '/img/linux.jpg',
      title: 'Linux BSP ',
      points: [
  "Customization of Linux kernel to support specific hardware platforms.",
  "Device drivers development for various peripherals such as UART, SPI, and I2C.",
  "Bootloader integration to initialize hardware before loading the Linux kernel.",
  "Optimization for resource-constrained embedded systems.",
  "Real-time Linux support for time-sensitive applications.",
  "Kernel module development and debugging for hardware interaction.",
  "Cross-compilation setup to build Linux images for target platforms.",
  "Integration of file systems and network protocols for embedded Linux systems.",
  "Security enhancements for embedded Linux systems, including secure boot and trusted execution environments."
],
    },
    {
      img: '/img/linux-2.jpg',
      title: 'Linux Based HMI',
     points: [
  "Custom Linux-based HMI solutions for intuitive user interfaces on embedded systems.",
  "Touchscreen integration with support for multi-touch gestures and haptic feedback.",
  "High-performance graphics rendering for smooth and responsive UI experiences.",
  "Optimization of system resources to ensure low power consumption for battery-operated devices.",
  "Real-time communication between the HMI and underlying hardware via protocols like SPI, I2C, or UART.",
  "Integration with IoT devices for remote monitoring and control of embedded systems.",
  "Support for various display resolutions and touch technologies (capacitive, resistive).",
  "Development of custom user interfaces with Qt, GTK, or other open-source UI frameworks.",
  "Security enhancements to protect user data and prevent unauthorized access in embedded systems."
],
    },
  ];

  // Navigation functions for carousel
  const nextCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardsData.length);
  };

  const prevCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardsData.length) % cardsData.length);
  };

  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Firmware Design Services"
        backgroundImage="/img/firmware.jpg"
        punchline="Empowering devices with efficient and reliable embedded intelligence."
      />

      <Breadcrumb current="Embedded" />

      <div className="aboutInfo">
        <div className="container hardware">
          <div className="card2-container">
            {isMobileView
              ? // Render all cards in stacked layout for mobile view
                cardsData.map((card, index) => (
                  <CardTwo
                    key={index}
                    img={card.img}
                    title={card.title}
                    points={card.points}
                  />
                ))
              : // Render one card with navigation for larger screens
                <>
                  <button onClick={prevCard} className="arrow-button arrow-left">
                    <img src="/img/leftarrow.png" alt="Previous" />
                  </button>

                  <CardTwo
                    img={cardsData[currentCardIndex].img}
                    title={cardsData[currentCardIndex].title}
                    points={cardsData[currentCardIndex].points}
                  />

                  <button onClick={nextCard} className="arrow-button arrow-right">
                    <img src="/img/right-arrow.png" alt="Next" />
                  </button>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Firmware;
